var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"seasons","title":"Season","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name'
    }
  ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }